import Immutable from 'immutable';

import {
  CLEAR_LEGAL_CARGO,
  CLEAR_LEGAL_CARGOS,
  FLAG_GETTING_LEGAL_CARGOS,
  GET_LEGAL_CARGO,
  FLAG_LEGAL_CARGO_ACTIVITY,
  GET_LEGAL_CARGOS,
} from '../../../actions/types/legal';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_LEGAL_CARGOS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_LEGAL_CARGOS:
      return state.setIn(['all', 'content'], Immutable.List(action.payload));
    case CLEAR_LEGAL_CARGOS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_LEGAL_CARGO_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_LEGAL_CARGO:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_LEGAL_CARGO:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
